import { Component, OnInit } from '@angular/core';
import { LogicParserService } from 'src/app/services/logic-parser.service';

@Component({
  standalone: true,
  selector: 'logic-test',
  templateUrl: './logic-test.component.html',
  styleUrls: ['./logic-test.component.scss'],
})
export class LogicTestComponent  implements OnInit {

  booleanExpressions: string[] = [];

  constructor(private logicParserService: LogicParserService) { }

  ngOnInit() {
    console.log('LogicTestComponent', 'ngOnInit', 'start');

    try {

      let testVarExp: string = "Z_Model IN ('HH') AND Z_Size IN ('06', '08') AND Z_Voltage NOT IN ('126')";
      let variables: string[] = this.logicParserService.extractVariables(testVarExp);
      console.log('LogicTestComponent', 'ngOnInit', 'variables', variables);

      this.booleanExpressions.push("'08' NOT IN ('04','06','08','12') OR '276' NOT IN ('246') OR '276' IN ('276')");
 
   this.booleanExpressions.push("'08' NOT IN ('04','06','08','12') OR '276' NOT IN ('246') OR '276' IN ('276') AND '08' NOT IN ('04','06','08','12') OR '276' NOT IN ('246') OR '276' IN ('276')");
 

      this.booleanExpressions.push("('ANY' IN ('04','06','08','10','12') AND '276' IN ('246')) OR ('ANY' IN ('06','08','10','12') AND ('276' IN ('276'))) OR '276' NOT IN ('126')");
   
      this.booleanExpressions.push("'06' IN ('06') AND 'F' IN ('F','E') AND '1' IN ('1') OR '06' IN ('10','12') AND 'F' IN ('R') AND '1' IN ('2','3')");
      this.booleanExpressions.push("'06' IN ('06') AND 'F' IN ('F','E') AND '1' IN ('1') OR '06' IN ('06','10','12') AND 'F' IN ('R','F') AND '1' IN ('1','2','3')");
      this.booleanExpressions.push("'HH' IN ('HH') AND '06' IN ('06','08','10','12') AND  '126' NOT IN ('126')");
      this.booleanExpressions.push("'08' NOT IN ('04','06','08','12')");
      this.booleanExpressions.push("'08' IN ('04','06','08','10','12') OR 'X' IN ('M','N','Q')");
      this.booleanExpressions.push("('08' IN ('04','06','08','10','12') AND ('X' IN ('M','N','Q') OR 'Y' IN ('Q','Z')))");
      this.booleanExpressions.push("('08' NOT IN ('04','06','10','12') AND ('X' IN ('M','N','Q') OR 'Y' NOT IN ('Q','Z')))");
      this.booleanExpressions.push("('08' IN ('04','06','08','10','12') AND ('X' IN ('M','N','Q') OR 'Y' IN ('Q','D','Z')))");
      this.booleanExpressions.push("('08' IN ('04','06','08','10','12') AND ('X' IN ('M','N','Q') OR 'Y' IN ('Q','Y','Z')))");
      this.booleanExpressions.push("('08' NOT IN ('04','06','08','10','12') OR ('X' IN ('M','N','Q') OR 'Y' NOT IN ('Q','Z')))");
      this.booleanExpressions.push("('08' NOT IN ('04','06','08','10','12') OR ('X' IN ('M','N','Q') OR 'Y' IN ('Q','Z')))");

      let results: string[] = [];
      for (let i = 0; i < this.booleanExpressions.length; i++) {
        let result = this.logicParserService.evaluateBooleanExpression(this.booleanExpressions[i]);
        results.push(result + ': ' + this.booleanExpressions[i]);
      }
      console.log('results',results);

      
    } catch (error) {
      console.log('LogicTestComponent', 'ngOnInit', 'ERROR', error);
    }

  }

}
